import React, { useState } from "react";
import { Container, Heading, VStack, Text, Box } from "@chakra-ui/react";
import AppointmentCard from "../components/AppointmentCard";
import { Appointment } from "../types";
import { myAppointments, physicians, locations } from "../data/mockData";

const MyAppointments: React.FC = () => {
  const [appointments, setAppointments] = useState<Appointment[]>(
    myAppointments as Appointment[]
  );
  const [activeTab, setActiveTab] = useState(0);

  // Simplified toast function
  const showToast = (title: string, description: string, status: string) => {
    alert(`${title}: ${description}`); // Simple fallback
  };

  const upcomingAppointments = appointments.filter(
    (appt) =>
      new Date(appt.startTime) > new Date() && appt.status === "confirmed"
  );

  const pastAppointments = appointments.filter(
    (appt) =>
      new Date(appt.startTime) <= new Date() || appt.status === "cancelled"
  );

  const handleCancelAppointment = (appointmentId: string) => {
    // In a real app, this would make an API call to cancel the appointment
    setAppointments(
      appointments.map((appt) =>
        appt.id === appointmentId ? { ...appt, status: "cancelled" } : appt
      )
    );

    showToast(
      "Appointment cancelled",
      "Your appointment has been successfully cancelled.",
      "info"
    );
  };

  const handleCheckIn = (appointmentId: string) => {
    // In a real app, this would make an API call to check in
    showToast(
      "Checked in!",
      "You've been successfully checked in. The doctor will see you shortly.",
      "success"
    );
  };

  return (
    <Container maxW="container.lg" py={8}>
      <VStack gap={6} align="stretch">
        <Heading as="h1" size="xl">
          My Appointments
        </Heading>

        <Box>
          <Box
            display="flex"
            borderBottom="1px solid"
            borderColor="gray.200"
            mb={4}
          >
            <Box
              px={4}
              py={2}
              cursor="pointer"
              borderBottom={activeTab === 0 ? "2px solid" : "none"}
              borderColor={activeTab === 0 ? "blue.500" : "transparent"}
              onClick={() => setActiveTab(0)}
            >
              Upcoming
            </Box>
            <Box
              px={4}
              py={2}
              cursor="pointer"
              borderBottom={activeTab === 1 ? "2px solid" : "none"}
              borderColor={activeTab === 1 ? "blue.500" : "transparent"}
              onClick={() => setActiveTab(1)}
            >
              Past
            </Box>
          </Box>

          {activeTab === 0 && (
            <Box>
              {upcomingAppointments.length > 0 ? (
                upcomingAppointments.map((appointment) => (
                  <AppointmentCard
                    key={appointment.id}
                    appointment={appointment}
                    physicians={physicians}
                    locations={locations}
                    onCancel={handleCancelAppointment}
                    onCheckIn={handleCheckIn}
                  />
                ))
              ) : (
                <Box p={6} textAlign="center">
                  <Text color="gray.500">
                    You have no upcoming appointments.
                  </Text>
                </Box>
              )}
            </Box>
          )}

          {activeTab === 1 && (
            <Box>
              {pastAppointments.length > 0 ? (
                pastAppointments.map((appointment) => (
                  <AppointmentCard
                    key={appointment.id}
                    appointment={appointment}
                    physicians={physicians}
                    locations={locations}
                    onCancel={handleCancelAppointment}
                    onCheckIn={handleCheckIn}
                  />
                ))
              ) : (
                <Box p={6} textAlign="center">
                  <Text color="gray.500">You have no past appointments.</Text>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </VStack>
    </Container>
  );
};

export default MyAppointments;
